import { render } from "./UncompressPackage.vue?vue&type=template&id=10c6a206&scoped=true"
import script from "./UncompressPackage.vue?vue&type=script&lang=js"
export * from "./UncompressPackage.vue?vue&type=script&lang=js"

import "./UncompressPackage.vue?vue&type=style&index=0&id=10c6a206&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c6a206"]])

export default __exports__